import { Context, createContext } from 'react';
import { ILetterSubmissionRequest } from '../models/ILetterGenerationRequest';
import { IUserProfile } from '../models/IUserProfile';

export interface IMetadataContext {
  showMetadataPanel: boolean;
  showPdfPanel: boolean;
  showSuccessGenerationPanel: boolean;
  showEmailedGenerationPanel: boolean;
  showMailedGenerationPanel: boolean;
  submissionRequest: ILetterSubmissionRequest | null;
  userProfile: IUserProfile;
  toggleMetadataPanel: (valueMetadata: boolean) => void;
  togglePdfPanel: (valuePdf: boolean) => void;
  toggleSuccessGenerationPanel: (value: boolean) => void;
  toggleEmailedGenerationPanel: (value: boolean) => void;
  toggleMailedGenerationPanel: (value: boolean) => void;
  clearSelectedLetter: () => void;
  setSubmissionRequest: (value: ILetterSubmissionRequest) => void;
  setUserProfile: (value: IUserProfile) => void;
}

export const MetadataContext: Context<IMetadataContext> = createContext<IMetadataContext>(
  {} as IMetadataContext
);
